import { Injectable } from '@angular/core'
import { first, map } from 'rxjs/operators'
import { FirestoreService2 } from './firestore.service2'
import { GlobalService } from './global.service'
import { use } from './utils'
import { chunkArray } from './utils'

@Injectable({ providedIn: 'root' })

export class DashboardService {

  constructor(
    private g: GlobalService,
    private fss: FirestoreService2
  ) { console.info(`## ${this.constructor.name}`) }

  getData() {
    if (!this.fss) this.fss = use<FirestoreService2>(FirestoreService2)
    return this.fss.list(`charts`, { where: [['active', '==', true]] })
  }

  getResults(chart) {
    if (!this.fss) this.fss = use<FirestoreService2>(FirestoreService2)
    const resultsFrom = chart.resultsFrom
    if (resultsFrom.collection) {
      const where = []
      if (resultsFrom.whereFilter && resultsFrom.whereFilter instanceof Array) {
        for (const wh of resultsFrom.whereFilter) {
          where.push([wh.field, wh.operation, wh.value])
        }
      }
      return this.fss.list(resultsFrom.collectionName, { where: where }).pipe(map(data => {
        const results = []
        const counter = {}
        data.forEach(function (obj) {
          const key = obj[resultsFrom.keyAtribute]
          counter[key] = (counter[key] || 0) + 1
        })
        Object.keys(counter).forEach(key => { results.push({ name: key, value: counter[key] }) })
        return results
      }))

    } else if (resultsFrom.document) {

    }
  }

  async getDataByUsercode(data: any[], config: any): Promise<any[]> {
    if (!data || !data.length) return []

    const userCodes = []
    const results = []

    for (let i = 0; i < data.length; i++) {
      const value = data[i]
      userCodes.push(value['usercode'].toLowerCase())
      // value.userData = await this.getUserData(config, value[ 'usercode' ].toLowerCase())
      this.getRankingLeaders(config, value['teamleader'] ? value['teamleader'].toLowerCase() : null)

      for (const key in value) {
        if (value.hasOwnProperty(key) && typeof value[key] === 'number' && key === 'rankingdate') value['rankingdate'] = new Date((value['rankingdate'] - (25567 + 2)) * 86400 * 1000).toISOString()
        if (value.hasOwnProperty(key) && typeof value[key] === 'number' && !['usercode', 'teamleader', 'rankingdate'].includes(key)) value[key] = +((value[key] / 100) * 100)
        if (key === 'usercode') value['usercode'] = value['usercode'].toLowerCase()
      }

      results.push({ ...value, rankingId: config.id });
    }

    config.rankingUsers = userCodes
    const updatedResults = await this.getUserData(results, userCodes)
    // console.log(updatedResults)
    return updatedResults
  }

  async getDataByRoles(data: any[], config: any): Promise<any[]> {
    if (!data || !data.length) return []
    const userCodes = []
    const results = []

    for (let i = 0; i < config.roleColumns.length; i++) {
      const nest = config.roleColumns[i]
      const aggregationMapForThisRole = {}

      for (let j = 0; j < data.length; j++) {
        const originalValue = data[j]
        const roleKeyValue = originalValue[nest].toLowerCase()
        userCodes.push(roleKeyValue)
        // originalValue.userData = await this.getUserData(config, roleKeyValue)

        if (roleKeyValue) {
          const value = { ...originalValue, role: nest }

          for (let h = i; h < config.roleColumns.length; h++) {
            this.getRankingRoles(config, roleKeyValue, config.roleColumns[h])
          }

          if (!aggregationMapForThisRole[roleKeyValue]) {
            for (const key in value) {
              if (value.hasOwnProperty(key) && typeof value[key] === 'number' && key === 'rankingdate') value['rankingdate'] = new Date((value['rankingdate'] - (25567 + 2)) * 86400 * 1000).toISOString()
              if (value.hasOwnProperty(key) && typeof value[key] === 'number' && ![...config.roleColumns, 'rankingdate'].includes(key)) value[key] = +((value[key] / 100) * 100)
              if (key === nest) value[nest] = value[nest].toLowerCase()
            }

            aggregationMapForThisRole[roleKeyValue] = { ...value, rankingId: config.id }
            results.push(aggregationMapForThisRole[roleKeyValue])
          } else {
            const existingAggregatedValue = aggregationMapForThisRole[roleKeyValue]

            for (const key in value) {
              if (Object.prototype.hasOwnProperty.call(value, key)) {
                if (typeof existingAggregatedValue[key] === "number" && typeof value[key] === 'number' && ![...config.roleColumns, 'rankingdate'].includes(key)) {
                  const processedIncomingNumber = +((value[key] / 100) * 100)
                  existingAggregatedValue[key] += processedIncomingNumber
                  existingAggregatedValue[key] = +((existingAggregatedValue[key] / 100) * 100).toFixed(2)
                }
              }
            }
          }
        }
      }
    }

    config.rankingUsers = userCodes
    const updatedResults = await this.getUserData(results, userCodes)
    // console.log(updatedResults)

    return updatedResults
  }

  private async getUserData(results: any[], userCodes: string[]): Promise<any> {
    if (!userCodes || !userCodes.length) return results
    let users = []

    if (userCodes && userCodes.length) {
      // TODO PF - When the angular update is done, change chunks from 10 to 30
      for (const chunk of chunkArray(userCodes, 10)) {
        users = [...users, ...(await this.fss.list('users', { api: true, where: [['userCode', 'in', chunk]] }).pipe(first()).toPromise())]
      }
      // console.log(users)
      for (const result of results) {
        const user = users.find(x => x.userCode === result.usercode)
        if (user) result.userData = { userCode: result.usercode, badges: user.badges || null, photoUrl: user.photoUrl || null, displayName: user.displayName }
        else result.userData = { displayName: result.usercode, userCode: result.usercode, photoUrl: null, badges: null }
      }
    }

    return results
  }

  getRankingLeaders(config: any, teamLeader: string = null) {
    if (teamLeader && !config.rankingLeaders.includes(teamLeader)) config.rankingLeaders = [...config.rankingLeaders, teamLeader]
  }

  getRankingRoles(config: any, userCode: string, role: string) {
    if (!config.rankingRoles[role]) config.rankingRoles[role] = []
    if (!config.rankingRoles[role].includes(userCode)) config.rankingRoles[role] = [...config.rankingRoles[role], userCode]
  }

  getChartData(data: any[], chart: any, id: string, roles: any[] = null): any[] {
    const results = []

    for (const item of data) {
      if (!item[item.role]) item.role = 'usercode'
      let newItem = { ...chart, id: `${id}_${item[item.role]}`, rankingDate: item['rankingdate'], role: item.role, userData: item.userData, usercode: item[item.role] }
      if (roles && roles.length) {
        for (const role of roles) {
          if (item[role]) newItem[role] = item[role].toLowerCase()
        }
      } else newItem.teamleader = item['teamleader'] ? item['teamleader'].toLowerCase() : null

      newItem.results = []

      if (chart.metrics && chart.metrics.length) {
        for (const metric of chart.metrics) {
          if (typeof item[metric.field] !== 'number') item[metric.field] = parseFloat(item[metric.field].replace(",", ".").match(/(\d+(\.\d+)?)/))[1]
          // console.log(item.usercode, metric.name, item[ metric.field ], +item[ metric.field ].replace(",", "."))
          if (!metric.group) newItem.results.push({ name: metric.name, value: +item[metric.field] || 0 })
          else {
            const group = newItem.results.find(x => x.name === metric.group)

            if (group) {
              group.series.push({ name: metric.name, value: +item[metric.field] || 0 })
            } else newItem.results.push({ name: metric.group, series: [{ name: metric.name, value: +item[metric.field] || 0 }] })
          }
        }
      }

      results.push(newItem)
    }

    return results
  }

  countDecimals(number) {
    const text = number.toString()
    // verify if number 0.000005 is represented as "5e-6"
    if (text.indexOf('e-') > -1) {
      const [base, trail] = text.split('e-')
      const deg = parseInt(trail, 10)
      return deg
    }
    // count decimals for number in representation like "0.123456"
    if (Math.floor(number) !== number) {
      return number.toString().split(".")[1].length || 0
    }
    return 0
  }

  getFilters(filterBy, data) {
    if (filterBy && filterBy.length) {
      const filters = []

      filterBy.forEach(filter => {
        const values = data.map(x => x[filter])
        const uniqueValues = [...new Set(values)]

        filters.push({ field: filter, values: uniqueValues })
      })

      return filters
    }
  }

}
